// Entity Types
export const GMC = "GMC";
export const CUSTOMER = "CUSTOMER";

export type EntityType = "GMC" | "CUSTOMER";

export const qboEntityType: { [key: string]: EntityType } = {
  GMC,
  CUSTOMER,
};

export type MappingType = {
  [key: string]: {
    id: string;
    name: string;
  };
};

export const mondayWebhookEvents = {
  item_deleted: "item_deleted",
  change_column_value: "change_column_value",
  change_status_column_value: "change_status_column_value",
  change_subitem_column_value: "change_subitem_column_value",
  change_specific_column_value: "change_specific_column_value",
  change_name: "change_name",
  create_item: "create_item",
  item_archived: "item_archived",
  item_moved_to_any_group: "item_moved_to_any_group",
  item_moved_to_specific_group: "item_moved_to_specific_group",
  item_restored: "item_restored",
  create_subitem: "create_subitem",
  change_subitem_name: "change_subitem_name",
  move_subitem: "move_subitem",
  subitem_archived: "subitem_archived",
  subitem_deleted: "subitem_deleted",
  create_column: "create_column",
  create_update: "create_update",
  edit_update: "edit_update",
  delete_update: "delete_update",
  create_subitem_update: "create_subitem_update",
};

export const QBO_ESTIMATE_URL = "https://app.qbo.intuit.com/app/estimate?txnId=";
export const QBO_INVOICE_URL = "https://app.qbo.intuit.com/app/invoice?txnId=";
export const QBO_CUSTOMER_URL = "https://app.qbo.intuit.com/app/customerdetail?nameId=";

export type OurRoles = "SUPERUSER" | "OPERATIONS" | "STANDARD" | "READ_ONLY" | "NO_ACCESS";

export const roles: Record<OurRoles, OurRoles> = {
  SUPERUSER: "SUPERUSER",
  OPERATIONS: "OPERATIONS",
  STANDARD: "STANDARD",
  READ_ONLY: "READ_ONLY",
  NO_ACCESS: "NO_ACCESS",
};

export type OurStages = "FIRST_TIME_SETUP" | "COMPLETE";

export const initStages: Record<OurStages, OurStages> = {
  // SUBSCRIBE: "SUBSCRIBE",
  // CONNECTIONS: "CONNECTIONS",
  // DATA_MAPPING: "DATA_MAPPING",
  FIRST_TIME_SETUP: "FIRST_TIME_SETUP",
  COMPLETE: "COMPLETE",
};

export const errorStates = {
  GOOGLE_REAUTH_REQUIRED: "GOOGLE_REAUTH_REQUIRED",
  NO_SUBSCRIPTION: "NO_SUBSCRIPTION",
  SEATS_UPGRADE_REQUIRED: "SEATS_UPGRADE_REQUIRED",
  UNAUTHORIZED: "UNAUTHORIZED",
  OTHER: "OTHER",
  NO_PERMISSION: "NO_PERMISSION",
  BOARD_NOT_CONFIGURED: "BOARD_NOT_CONFIGURED",
  API_ERROR: "API_ERROR",
  SENTRY: "SENTRY",
  UNKNOWN: "UNKNOWN",
};

export type CapturedErrorTypes = (typeof errorStates)[keyof typeof errorStates];
